import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import getContentProgress from 'utils/asset/getContentProgress';
import getUserId from 'utils/session/getUserId';
import formatRankForDisplay from 'utils/ui/formatRankForDisplay';
import checkIsEditableAsset from 'utils/checkIsEditableAsset';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { checkIsAssetOrAuxiliaryContent, checkIsNestedPlaylist, checkIsPlaylist, checkIsTopic, checkIsPlaylistContent } from 'types/content/utils';
import { useToggleSaveMyContent } from 'actions/content';
import useProcessingFileStatus from 'actions/file/useProcessingFileStatus';
import { FILE_STATUS_VALUES } from 'actions/file';
import { useUpdateAssets } from 'actions/assets';
import FriendlyDuration from 'components/FriendlyDuration';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
import { ExternalLink, InfoIcons, ProcessingStatus } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import { GoalPill, NextUpPill, SharedWithYouPill, LatestInteractionPill } from 'components/Pill';
import AssetManager from 'screens/AssetManager';
import { formatAssetEditorPayloadForApi } from 'screens/AssetEditor';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var StyledCardButton = styled(Button).withConfig({
  displayName: "useCardController__StyledCardButton",
  componentId: "sc-1ldzqt6-0"
})(["background-color:transparent;"]);
export function useCardController(_ref) {
  var _contentItem$author;
  var collectionId = _ref.collectionId,
    priorityPillType = _ref.priorityPillType,
    _ref$progressInfoRead = _ref.progressInfoReadoutType,
    progressInfoReadoutType = _ref$progressInfoRead === void 0 ? 'full' : _ref$progressInfoRead,
    contentItem = _ref.contentItem,
    playlist = _ref.playlist,
    _ref$canSaveForLater = _ref.canSaveForLater,
    canSaveForLater = _ref$canSaveForLater === void 0 ? true : _ref$canSaveForLater,
    onWebAssetClick = _ref.onWebAssetClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = contentItem.id,
    completionTime = contentItem.completionTime,
    commentCount = contentItem.commentCount,
    commentCountUser = contentItem.commentCountUser,
    goal = contentItem.goal,
    thumbnailId = contentItem.thumbnailId,
    isDimmed = contentItem.isDimmed,
    userContentStatus = contentItem.userContentStatus;
  var latestInteraction = 'latestInteraction' in contentItem ? contentItem.latestInteraction : undefined;
  var _useModalQueryParam = useModalQueryParam("edit-content-".concat(id)),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasAssetEditor = _useModalQueryParam2[0],
    toggleAssetEditor = _useModalQueryParam2[1];
  var type = getContentItemType(contentItem);
  var isPlaylist = checkIsPlaylist(contentItem);
  var isNestedPlaylist = checkIsNestedPlaylist(contentItem, {
    parentPlaylist: playlist
  });
  var isTopic = checkIsTopic(contentItem);
  var isAssetOrAuxiliaryContent = checkIsAssetOrAuxiliaryContent(contentItem);
  var isAsset = !isPlaylist && !isTopic && !isNestedPlaylist;
  var contentCount = isPlaylist ? contentItem.contentCount : 0;
  var audience = isPlaylist ? contentItem.audience || 'all' : 'all';
  var badge = isPlaylist ? contentItem.badge : undefined;
  var hasUserBadge = isPlaylist ? contentItem.hasUserBadge : false;
  var completionRate = isPlaylist ? contentItem.completionRate : 0;
  var collection_id = isAssetOrAuxiliaryContent ? contentItem.collection_id : undefined;
  var duration = isAssetOrAuxiliaryContent ? contentItem.duration : undefined;
  var fileId = isAssetOrAuxiliaryContent ? contentItem.fileId : undefined;
  var openInIframe = isAssetOrAuxiliaryContent ? contentItem.openInIframe : undefined;
  var userScormAssetStatus = isAssetOrAuxiliaryContent ? contentItem.userScormAssetStatus : undefined;
  var download = isAssetOrAuxiliaryContent ? contentItem.download : undefined;
  var isSaved = contentItem.isSaved;
  var location = useLocation();
  var getAssetLink = function getAssetLink() {
    var search = location.search,
      pathname = location.pathname;
    var searchParams = queryparse(search);
    if (contentItem.type === 'playlist') {
      return "/playlists/".concat(id);
    } else if (contentItem.type === 'topic') {
      return "/browse/".concat(id);
    } else {
      return createLocation(pathname, _objectSpread(_objectSpread({}, searchParams), {}, {
        asset: id,
        collectionId: collectionId,
        isPublished: audience !== 'admin',
        modal: undefined,
        size: undefined
      }));
    }
  };
  var translatableType = getContentItemTypeTranslationKey(type);
  var icon = getContentItemIconFromType(type);
  var itemDuration = completionTime ? completionTime * 60 : duration;
  var isContributingUserAuthor = getUserId() === ((_contentItem$author = contentItem.author) === null || _contentItem$author === void 0 ? void 0 : _contentItem$author.id);
  var isAssetEditable = checkIsEditableAsset({
    contentItem: contentItem
  });
  var assetFileStatus = isAssetOrAuxiliaryContent ? contentItem.fileStatus : undefined;
  var _useProcessingFileSta = useProcessingFileStatus({
      fileId: fileId,
      parentPlaylistId: (playlist === null || playlist === void 0 ? void 0 : playlist.id) || collection_id,
      assetId: id,
      oldFileStatus: assetFileStatus,
      refetchInterval: 5000,
      assetFileStatus: assetFileStatus
    }),
    fileStatus = _useProcessingFileSta.fileStatus,
    isProcessingStatusShowing = _useProcessingFileSta.isProcessingStatusShowing;
  var assetMustBeDownloaded = download === 'required';
  var hasProcessingStatus = !isPlaylist && !assetMustBeDownloaded && isProcessingStatusShowing;
  var shouldShowAsNotAvailable = hasProcessingStatus && !isAssetEditable && !isContributingUserAuthor;
  var _useToggleSaveMyConte = useToggleSaveMyContent({
      id: contentItem.id,
      isSaved: !isSaved,
      isAsset: isAsset
    }),
    toggleSaveContent = _useToggleSaveMyConte.toggleSaveContent;
  function toggleSaved() {
    return _toggleSaved.apply(this, arguments);
  }
  function _toggleSaved() {
    _toggleSaved = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return toggleSaveContent({
              id: contentItem.id,
              isAsset: isAsset
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _toggleSaved.apply(this, arguments);
  }
  var canSavePlaylist = isPlaylist && canSaveForLater;
  var menuItemsArray = [];
  if (isAsset || canSavePlaylist) {
    menuItemsArray.push({
      value: t(isSaved ? 'actions_remove_from_save_for_later' : 'actions_save_for_later'),
      icon: 'favourite',
      onSelect: toggleSaved
    });
  }
  var progress = getContentProgress({
    isPlaylist: isPlaylist,
    userContentStatus: userContentStatus,
    userScormAssetStatus: userScormAssetStatus,
    completionRate: completionRate
  });
  var visibilityStatus;
  if (shouldShowAsNotAvailable) {
    visibilityStatus = 'unavailable';
  } else if (isPlaylist && audience === 'admin') {
    visibilityStatus = 'private';
  }
  var infoIcons = /*#__PURE__*/_jsx(InfoIcons, {
    isSaved: isSaved,
    likeCount: contentItem.rating_count,
    hasUserLiked: contentItem.user_rated_like,
    visibility: visibilityStatus,
    commentCount: commentCount,
    commentCountUser: commentCountUser,
    isOptional: 'optional' in contentItem && contentItem.optional,
    playlistName: playlist === null || playlist === void 0 ? void 0 : playlist.name
  });
  var subtitle;
  if (shouldShowAsNotAvailable) {
    subtitle = t('content_currently_not_available');
  } else {
    subtitle = /*#__PURE__*/_jsxs(InlineList, {
      splitBy: "dot",
      children: [/*#__PURE__*/_jsx(_Fragment, {
        children: t(translatableType)
      }), itemDuration && itemDuration > 0 && /*#__PURE__*/_jsx(FriendlyDuration, {
        value: itemDuration
      }), isPlaylist && contentCount && /*#__PURE__*/_jsx(_Fragment, {
        children: t('playlist_item_count', {
          count: contentCount
        })
      }), type !== 'topic' && progress && /*#__PURE__*/_jsx(ContentProgressCircle, {
        progress: progress,
        contentName: contentItem.name,
        infoReadout: progressInfoReadoutType,
        scale: 5 / 6
      }), contentItem.type === 'web' && openInIframe === false && /*#__PURE__*/_jsx(ExternalLink, {
        webUrl: contentItem.webUrl || '',
        assetName: contentItem.name,
        onWasClicked: onWebAssetClick
      }), hasProcessingStatus && fileStatus && /*#__PURE__*/_jsx(ProcessingStatus, {
        status: fileStatus
      }), hasProcessingStatus && fileStatus === FILE_STATUS_VALUES.INVALID && /*#__PURE__*/_jsx(StyledCardButton, {
        z: "raised",
        size: "small",
        icon: "edit",
        mt: -4,
        onClick: toggleAssetEditor,
        variant: "default-negative",
        children: t('actions_try_again')
      })]
    });
  }
  var priorityPillMap = {
    next: /*#__PURE__*/_jsx(NextUpPill, {}),
    goal: goal ? /*#__PURE__*/_jsx(GoalPill, {
      goal: goal
    }) : undefined,
    shared: /*#__PURE__*/_jsx(SharedWithYouPill, {}),
    latestInteraction: latestInteraction ? /*#__PURE__*/_jsx(LatestInteractionPill, {
      latestInteraction: latestInteraction
    }) : undefined
  };
  var hasPlaylistNumbering = !!(playlist !== null && playlist !== void 0 && playlist.hasPlaylistNumbering);
  var _useUpdateAssets = useUpdateAssets({
      assetIds: [id],
      parentPlaylistIds: playlist === null || playlist === void 0 ? void 0 : playlist.id,
      hasSuccessAlert: true
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  function submitAssetEditor(_x) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var changes, formattedData;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            changes = _ref2.changes;
            formattedData = formatAssetEditorPayloadForApi({
              changes: changes,
              parentPlaylistId: playlist === null || playlist === void 0 ? void 0 : playlist.id
            });
            _context2.next = 1;
            return updateAssets(formattedData);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  var modalSlot = hasAssetEditor && isAssetOrAuxiliaryContent && /*#__PURE__*/_jsx(AssetManager, {
    inContentManagerContext: false,
    hasOpenOption: false,
    assets: [contentItem],
    parentPlaylist: playlist,
    onClose: toggleAssetEditor,
    onSubmit: submitAssetEditor
  });
  return {
    hasPlaylistNumbering: hasPlaylistNumbering,
    infoIcons: infoIcons,
    badge: badge,
    hasUserBadge: hasUserBadge,
    priorityPill: priorityPillType ? priorityPillMap[priorityPillType] : undefined,
    description: contentItem.description,
    id: contentItem.id,
    icon: icon,
    imageSource: getPictureUrl({
      id: thumbnailId,
      dimensions: DIMENSIONS.HORIZONTAL_CARD
    }),
    isDisabled: hasProcessingStatus,
    isDimmed: hasProcessingStatus || isDimmed,
    link: getAssetLink(),
    menuItems: menuItemsArray.length ? menuItemsArray : undefined,
    title: contentItem.name,
    subtitle: subtitle,
    rank: checkIsPlaylistContent(contentItem) ? formatRankForDisplay(contentItem.rank) : undefined,
    modalSlot: modalSlot
  };
}